import { ProductTokens } from '../types'
import { colors } from './colors'

export const thewest: ProductTokens = {
    colors,
}
